<template>
    <div class="field">
        <div>
            <div class="fieldLabel" :class="{'p-error': invalid}">
                <span>{{ label }}</span>
                <i v-if="infoTooltipLeft" class="pi pi-info-circle"
                   v-tooltip.left="infoTooltipLeft"
                ></i>
                <i v-if="infoTooltipRight" class="pi pi-info-circle"
                   v-tooltip.right="infoTooltipRight"
                ></i>
                <i v-if="infoTooltipTop" class="pi pi-info-circle"
                   v-tooltip.top="infoTooltipTop"
                ></i>
                <i v-if="infoTooltipBottom" class="pi pi-info-circle"
                   v-tooltip.bottom="infoTooltipBottom"
                ></i>
            </div>
            <component :is="elementName" :model-value="modelValue" :id="id" v-bind="$attrs"
                       :data-cy="$attrs.dataField || label"
                       v-inputchars="$attrs.inputchars || false"
                       :class="{'p-invalid': invalid}">
                <slot v-if="slotText">{{ slotText }}</slot>
            </component>
        </div>
        <small v-if="invalid" class="p-error" v-html="invalidMessage"></small>
    </div>
</template>

<script setup>
import { computed } from "vue";
import _ from "lodash-es";

const props = defineProps({
    modelValue: {},
    label: String,
    elementName: {
        required: true
    },
    id: {
        type: String,
        default: _.uniqueId('FormField_')
    },
    required: {
        type: Boolean,
        default: false
    },
    invalidValue: Boolean,
    invalidValueMessage: String,
    helperFile: String,
    infoTooltipRight: String|Object,
    infoTooltipLeft: String|Object,
    infoTooltipTop: String|Object,
    infoTooltipBottom: String|Object,
    slotText: String
});

const invalid = computed(() => {
    //the validation can come from outside as a prop (this.invalidValue)
    //or it is considered invalid if the field is required and no value is provided
    return props.invalidValue || (props.required && !props.modelValue);
});

const invalidMessage = computed(() => {
    //if validation comes from outside
    if (props.invalidValue) {
        return props.invalidValueMessage;
    }
    //default error for required component
    if (props.required) {
        return 'Field is required';
    }
    //no message should be required at this point
    return '';
});
</script>

<style scoped>
.field {
    margin-bottom: 5px;
}
.fieldLabel {
    font-weight: 700;
    display: flex;
    gap: 5px;
    margin-bottom: 5px;
}
.invalidMessage {
    font-size: smaller;
    overflow: auto;
}
</style>